import Vue from 'vue'
export function isOverflow(element) {
  if (element.scrollWidth > element.offsetWidth) {
    return element
  }
  return null
}
// 3.4人事修改
export function isOverflowY(element) {
  if (element.scrollHeight > element.offsetHeight) {
    return element
  }
  return null
}
function getMaxZIndex() {
  let maxZIndex = 0
  const elements = document.body.children
  for (let i = 0; i < elements.length; i++) {
    const zIndex = parseInt(window.getComputedStyle(elements[i])['z-index'])
    if (!isNaN(zIndex) && zIndex > maxZIndex) {
      maxZIndex = zIndex
    }
  }
  return maxZIndex
}
export default {
  bind(el, binding) {
    let tooltip = null
    let timer = null
    const { value } = binding
    const { auto, html } = binding.modifiers // 3.4人事修改
    const childItem = value && el.querySelector(value)
    const tooltipDom = childItem || el
    // console.log('tooltipDom', tooltipDom)
    tooltipDom.addEventListener('mouseenter', function() {
      if (auto && !value) {
        tooltipDom.style.whiteSpace = 'nowrap'
        tooltipDom.style.overflow = 'hidden'
        tooltipDom.style.textOverflow = 'ellipsis'
      }
      const overflowElement = isOverflow(tooltipDom) || (html ? isOverflowY(tooltipDom) : null) // 3.4人事修改
      console.log('overflowElement', overflowElement)
      if (!overflowElement) return
      timer && clearTimeout(timer)
      timer = null
      const rect = overflowElement.getBoundingClientRect()
      overflowElement && initTooltip()
      function initTooltip() {
        timer && clearTimeout(timer)
        timer = null
        if (!tooltip) {
          tooltip = document.createElement('div')
          tooltip.className = `el-tooltip__popper my-tooltip-wrapper${html ? ' my-tooltip-html' : ''} is-dark` // 3.4人事修改
          tooltip.style.position = 'absolute'
          tooltip.style.zIndex = `${getMaxZIndex() + 1 > 1000 ? getMaxZIndex() + 1 : 1000}`
          // tooltip.style.maxHeight = '250px'
          tooltip.style.maxWidth = '750px'
          // tooltip.style.overflowY = 'auto'
          tooltip.style.opacity = '0'
          tooltip.style.transition = 'opacity 0.5s'
          tooltip.style.padding = '0'
          // 3.4人事修改
          const tooltipContent = html ? overflowElement.innerHTML : (overflowElement.tagName === 'INPUT' ? overflowElement.value : overflowElement.textContent)
          const maxHeight = html ? 'max-height: 400px;max-height: min(400px, 50vh);' : 'max-height: 250px;'
          tooltip.innerHTML = `<div class="my-scroll-wrapper" style="${maxHeight}overflow-y: auto;padding: 8px 12px;">${tooltipContent}</div>`
          // 3.4人事修改
          if (html) {
            // 富文本内的链接新窗口打开，保证可点击下载且不离开当前页
            tooltip.querySelectorAll('a').forEach(a => {
              a.setAttribute('target', '_blank')
              a.setAttribute('rel', 'noopener noreferrer')
            })
          }
          tooltip.style.left = `${rect.left + window.scrollX + (rect.width / 2)}px`
          document.body.appendChild(tooltip)

          window.requestAnimationFrame(() => {
            const tooltipRect = tooltip.getBoundingClientRect()
            console.log('rect.top', rect.top, tooltipRect)
            tooltip.style.top = `${rect.top + window.scrollY - tooltipRect.height > 16 ? rect.top + window.scrollY - tooltip.offsetHeight - 8 : rect.top + rect.height}px`
            const left = window.scrollX + rect.left + (overflowElement.offsetWidth / 2) - (tooltipRect.width / 2) > 16 ? rect.left + (overflowElement.offsetWidth / 2) - (tooltipRect.width / 2) : 16
            tooltip.style.left = `${left}px`
            window.getComputedStyle(tooltip).opacity
            tooltip.style.opacity = '1'
          })
          tooltip.addEventListener('mouseenter', function() {
            tooltip.style.opacity = '1'
            tooltip.isHovered = true
            timer && clearTimeout(timer)
            timer = null
          })
          tooltip.addEventListener('mouseleave', function() {
            tooltip.isHovered = false
            tooltip.style.opacity = '0'
            timer = setTimeout(() => {
              tooltip && document.body.removeChild(tooltip)
              tooltip = null
              timer && clearTimeout(timer)
              timer = null
            }, 500)
          })
        } else {
          const tooltipRect = tooltip.getBoundingClientRect()
          tooltip.style.top = `${rect.top + window.scrollY - tooltipRect.height > 16 ? rect.top + window.scrollY - tooltip.offsetHeight - 8 : rect.top + rect.height}px`
          const left = window.scrollX + rect.left + (overflowElement.offsetWidth / 2) - (tooltipRect.width / 2) > 16 ? rect.left + (overflowElement.offsetWidth / 2) - (tooltipRect.width / 2) : 16
          tooltip.style.left = `${left}px`
          window.getComputedStyle(tooltip).opacity
          tooltip.style.opacity = '1'
          console.log('宠幸定位', tooltip.style.top, tooltip.style.left)
        }
      }
    })
    tooltipDom && tooltipDom.addEventListener('mouseleave', function() {
      if (tooltip && !tooltip.isHovered) {
        tooltip && (tooltip.style.opacity = '0')
        timer = setTimeout(() => {
          tooltip && document.body.removeChild(tooltip)
          tooltip = null
          timer && clearTimeout(timer)
          timer = null
        }, 500)
      }
    })
  }
}
